const nearlyEqual = (num1: number, num2: number, epsilon = 0.001): boolean => {
    return Math.abs(num1 - num2) < epsilon;
};

export default nearlyEqual;
